<template>
  <div id="vue-app">
      <div class="container mt">
      <div class="form-container">
          <div class="error" v-if="error!==''">
              <p>{{ error }}</p>
          </div>
          <div class="confirmation" v-if="confirmation">
              <p>Your password has been updated!</p>
              <router-link to="/available-properties/login">Click here to login</router-link>
          </div>
          <form>
                <label for="password">New Password</label>
                <input type="password" class="" name="password" id="password" v-model="password">
                <label for="confirm_password">Confirm New Password</label>
                <input type="password" class="" name="confirm_password" id="confirm_password" v-model="confirm_password">
            </form>
            <button v-on:click="send">Reset password</button>
        </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ApplicationResetPassword',

  data() {
    return {
        password: '',
        confirm_password: '',
        error: '',
        confirmation: false,
        username: '',
        epoch: '',
        verification_signature: '',
    }
  },
  created() {
        window.scrollTo(0,0);

  },
  methods: {
      send() {

          // First, check if passwords match
          if (this.password === this.confirm_password) {

            // Before sending, make sure that we have the URL parameters we need
            if (window.location.search != '') {
                var queries = window.location.search.substring(1);
                if (this.$parent.includes(queries, 'username=')) {
                    var queryItems = queries.split('&');
                    for (var item of queryItems) {
                        var keyValuePair = item.split("=");
                        if (keyValuePair[0] == 'username') {
                            this.$set(this, 'username', decodeURIComponent(keyValuePair[1]));
                        }
                        if (keyValuePair[0] == 'verification_signature') {
                            this.$set(this, 'verification_signature', decodeURIComponent(keyValuePair[1]));
                        }
                        if (keyValuePair[0] == 'epoch') {
                            this.$set(this, 'epoch', decodeURIComponent(keyValuePair[1]));
                        }
                    }
                }

                if (this.username != '' && this.verification_signature != '' && this.epoch != '') {
                    axios.post('/wp-json/HCLRC/v1/finish-public-user-password-reset/', {
                        userEmail: this.username, epoch: this.epoch, userPassword: this.password, verification_signature: this.verification_signature
                        }).then(res => {
                            console.log(res);
                            if (res.data.data.status == "OK") {
                                this.$set(this, 'confirmation', true);

                            } else {
                                this.$set(this, 'error', true);
                            }
                        
                    })
                    .catch(function (error) {
                        // if an error occurs, print that error
                        console.log(error);

                    });
                } else {
                    this.$set(this, 'error', 'Your reset password link is invalid. Please try again.');
                }


           
          }
        } else {
            this.$set(this, 'error', 'Your passwords do not match.');
        }
              
            
          
         
      },
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.error {
    background-color: #dc3b43;
    padding: 1rem;
    margin-bottom: 2rem;
    p {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
    }
}
.confirmation {
    border: 3px solid rgba(37, 114, 130, .3);
    padding: .5rem;
    text-align: center;
    margin-bottom: 2rem;
    p {
        font-weight: 700;
    }
    a {
        text-transform: none;
        color: #dc3b43;
        font-weight: 700;
    }
}
.form-container {
    text-align: center;
    form {
    display: flex;
    flex-direction: column;
    width: 40%;
    margin: 0 auto;
    label {
        font-weight: 600;
        margin-bottom: 0;
        text-align: left;
    }
    input {
        font-family: "neue-haas-unica";
        border: 1px solid rgba(37, 114, 130, .3);
        margin-bottom: 1rem;
        font-size: 1rem;

        
    }
}
button {
    font-size: 1.25rem;
    font-family: 'din-2014';
    font-weight: 600;
    padding: .75rem 5rem;
    background-color: #dc3b43;
    color: #fff;
    font-size: 1rem;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: all .5s;

    &:hover, &:focus, &.active {
        background-color: #A12127;
    }
}
}


</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationResetPassword.vue